var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb u-bg--white"},[_c('simple-link',{staticClass:"u-color--blue",attrs:{"text":'Accueil',"href":'/'}}),_c('span',[_vm._v(" > "+_vm._s(_vm.text)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }